export {FilePreview} from './FilePreview';
export type {FilePreviewProps} from './FilePreview';
export type {FileType, FilePreviewAction} from './types';
export {getFileType} from './utils';
